import React from 'react';

import useSound from 'use-sound';
import sfxSprites from '../../assets/sfx/sfx.json';
import sfxAudio from '../../assets/sfx/sfx.m4a';

import { Link } from 'gatsby';
import classNames from 'classnames';

export default function Button({ href, className, sfx, children }) {
	const [play, { stop }] = useSound(sfxAudio, {
		volume: 0.25,
		sprite: {
			...sfxSprites.sprite,
		},
	});

	return (
		<Link
			to={href}
			className={classNames('btn', className)}
			onMouseEnter={() => {
				sfx && play({ id: sfx });
			}}
			onMouseLeave={() => {
				sfx && stop();
			}}
			onMouseDown={() => {
				sfx && stop();
			}}
		>
			{children}
		</Link>
	);
}
